import React, { useEffect, useRef } from 'react';
import { ImageOptimizeProps } from './interface';

const ImageSplitOptimize: React.FC<ImageOptimizeProps> = props => {
  const { tips = ['优化前', '优化后'],
    imgList,
    getImgStatus,
    getImgState,
    getIsMoblie } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  function handleRightImgLoad() {
    const img = imgRef?.current;
    const container = containerRef?.current;
    if (!img || !container) return;

    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;

    const scale = Math.min(containerWidth / img.naturalWidth, containerHeight / img.naturalHeight, 1);
    const oImgState = {
      imgWidth: Math.floor(img.naturalWidth * scale),
      imgHeight: Math.floor(img.naturalHeight * scale),
      imgLeft: 0,
      transform: { scaleX: scale, scaleY: scale, offsetY: 0, offsetX: 0 },
    };

    if (getImgState) getImgState(oImgState);
    if (getImgStatus) getImgStatus(false);
  }

  function handleImgError() {
    if (getImgStatus) getImgStatus(false);
  }

  useEffect(() => {
    if (window.outerWidth <= 768) {
      if (getIsMoblie) getIsMoblie(true);
    }
  }, [getIsMoblie]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        gap: '8px',
      }}
    >
      {/* 左侧：切边增强图 */}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#F2F6FA',
        }}
      >
        <span
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            background: '#0052d9',
            color: '#fff',
            fontSize: '12px',
            padding: '0 8px',
            height: '22px',
            lineHeight: '22px',
            zIndex: 1,
          }}
        >
          {tips[0]}
        </span>
        <img
          src={imgList[0]}
          alt=""
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
          }}
        />
      </div>

      {/* 右侧：原图 */}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#F2F6FA',
        }}
      >
        <span
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            background: '#0052d9',
            color: '#fff',
            fontSize: '12px',
            padding: '0 8px',
            height: '22px',
            lineHeight: '22px',
            zIndex: 1,
          }}
        >
          {tips[1]}
        </span>
        <img
          src={imgList[1]}
          alt=""
          ref={imgRef}
          onLoad={handleRightImgLoad}
          onError={handleImgError}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
          }}
        />
      </div>
    </div>
  );
};

export default ImageSplitOptimize;
